import { ReactElement, ReactNode, useState } from "react"
import { useParams } from "react-router-dom"
import { v4 as uuid4 } from "uuid"

import AmendEVACDeviceProvider from "./baseProviders/amendEVACDeviceProvider"
import useStartNewEvacDeviceAmendment from "../../../../../services/middleware/hooks/devices/lct/useStartNewEvacDeviceAmendment"

interface INewEVACDeviceAmendmentFormUrlParams {
    deviceRef: string
}

interface INewEVACDeviceAmendmentProviderProps {
    children: ReactNode
}

const NewEVACDeviceAmendmentProvider = ({
    children,
}: INewEVACDeviceAmendmentProviderProps): ReactElement => {
    const { deviceRef: urlDeviceRef } = useParams<
        keyof INewEVACDeviceAmendmentFormUrlParams
    >() as INewEVACDeviceAmendmentFormUrlParams

    const [attachmentUUID] = useState<string>(uuid4())

    const {
        data: formData,
        setData: setFormData,
        isLoading,
        error: newEVACDeviceAmendmentError,
    } = useStartNewEvacDeviceAmendment(urlDeviceRef, attachmentUUID)

    return (
        <AmendEVACDeviceProvider
            formData={formData}
            setFormData={setFormData}
            formDataIsLoading={isLoading}
            formDataError={newEVACDeviceAmendmentError}
            attachmentUUID={attachmentUUID}
            systemReference={urlDeviceRef}
        >
            {children}
        </AmendEVACDeviceProvider>
    )
}

export default NewEVACDeviceAmendmentProvider
